define("shared/components/shared/ui/banner", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/service"], function (_exports, _component, _templateFactory, _component2, _service) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/service",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="o--page__banner">
    {{#unless @isHidden}}
  
      <div class={{if @className @className}}>
  
        {{#if @text}}
  
          <p class="u--text--light u--text--md u--m__b__0">
            {{@text}}
  
            {{#if this.showTooltip}}
              <Shared::Ui::IconTooltip
                @tooltip={{t "analytics.tooltips.instagram_business_profile"}}
              />
            {{/if}}
  
            {{#if @link}}
              <a
                href={{@link}}
                target="_blank"
                rel="noopener noreferrer"
                title={{if @title @title}}
                class={{if @showButton "o--btn o--btn--default u--m__l"}}
              >
                {{@linkText}}
              </a>
            {{/if}}
  
            {{#if @linkTo}}
              <LinkTo
                class={{if @showButton "o--btn o--btn--default u--m__l"}}
                title={{if @title @title}}
                @route={{@linkTo}}
              >
                {{@linkText}}
              </LinkTo>
            {{/if}}
  
            {{#if @actionMethod}}
              <a
                title={{if @title @title}}
                class={{if @showButton "o--btn o--btn--default u--m__l"}}
                onclick={{action @actionMethod}}
              >
                {{@linkText}}
              </a>
            {{/if}}
  
          </p>
  
        {{/if}}
  
      </div>
  
      {{yield}}
  
    {{/unless}}
  </div>
  
  */
  {
    "id": "Mh/naEgx",
    "block": "[[[10,0],[14,0,\"o--page__banner\"],[12],[1,\"\\n\"],[41,[51,[30,1]],[[[1,\"\\n    \"],[10,0],[15,0,[52,[30,2],[30,2]]],[12],[1,\"\\n\\n\"],[41,[30,3],[[[1,\"\\n        \"],[10,2],[14,0,\"u--text--light u--text--md u--m__b__0\"],[12],[1,\"\\n          \"],[1,[30,3]],[1,\"\\n\\n\"],[41,[30,0,[\"showTooltip\"]],[[[1,\"            \"],[8,[39,2],null,[[\"@tooltip\"],[[28,[37,3],[\"analytics.tooltips.instagram_business_profile\"],null]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,4],[[[1,\"            \"],[10,3],[15,6,[30,4]],[14,\"target\",\"_blank\"],[14,\"rel\",\"noopener noreferrer\"],[15,\"title\",[52,[30,5],[30,5]]],[15,0,[52,[30,6],\"o--btn o--btn--default u--m__l\"]],[12],[1,\"\\n              \"],[1,[30,7]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,8],[[[1,\"            \"],[8,[39,4],[[16,0,[52,[30,6],\"o--btn o--btn--default u--m__l\"]],[16,\"title\",[52,[30,5],[30,5]]]],[[\"@route\"],[[30,8]]],[[\"default\"],[[[[1,\"\\n              \"],[1,[30,7]],[1,\"\\n            \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,9],[[[1,\"            \"],[10,3],[15,\"title\",[52,[30,5],[30,5]]],[15,0,[52,[30,6],\"o--btn o--btn--default u--m__l\"]],[15,\"onclick\",[28,[37,5],[[30,0],[30,9]],null]],[12],[1,\"\\n              \"],[1,[30,7]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n        \"],[13],[1,\"\\n\\n\"]],[]],null],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[18,10,null],[1,\"\\n\\n\"]],[]],null],[13],[1,\"\\n\"]],[\"@isHidden\",\"@className\",\"@text\",\"@link\",\"@title\",\"@showButton\",\"@linkText\",\"@linkTo\",\"@actionMethod\",\"&default\"],false,[\"unless\",\"if\",\"shared/ui/icon-tooltip\",\"t\",\"link-to\",\"action\",\"yield\"]]",
    "moduleName": "shared/components/shared/ui/banner.hbs",
    "isStrictMode": false
  });

  let Banner = (_class = class Banner extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "intl", _descriptor, this);
    }

    get showTooltip() {
      const str = this.args.text;
      const subStr = this.intl.t('analytics.general.instagram_business_profile');
      return str.includes(subStr);
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  _exports.default = Banner;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, Banner);
});